export enum ColumnAttachType {
  FlushInner = 'flush-inner',
  FlushOuter = 'flush-outer',
  Centered = 'centered',
  None = 'none',
}
